/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { array, func, object } from 'prop-types';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import { bpWidth, colors } from '../../../styles/variables';

const VariantSelectionContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;

  @media (${bpWidth.desktopSm}) {
    padding-bottom: 15px;
  }
`;

const VariantSelection = styled.div`
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 20px;
  margin-bottom: 10px;
  height: 26px;
  width: 26px;
  box-sizing: border-box;

  &.active {
    border: 1px solid ${colors.gray200};
  }

  @media (${bpWidth.desktopSm}) {
    margin-right: 10px;
    margin-bottom: 0;
    height: 21px;
    width: 21px;
  }
`;

const VariantOption = styled.div`
  &.boardwalkBeige,
  &.red,
  &.signalRed,
  &.sparkCitron,
  &.shadowBlack,
  &.twilightBlue,
  &.thunderGray,
  &.gray,
  &.black,
  &.rapidBlue,
  &.espressoBrown,
  &.starWars,
  &.grogu™Gitamini {
    border-radius: 50%;
    height: 20px;
    width: 20px;
  }

  &.boardwalkBeige {
    background-color: ${colors.boardwalkBeige};
  }
  &.red {
    background-color: ${colors.red};
  }
  &.signalRed {
    background-color: ${colors.signalRed};
  }
  &.sparkCitron {
    background-color: ${colors.sparkCitron};
  }
  &.shadowBlack {
    background-color: ${colors.black};
  }
  &.twilightBlue {
    background-color: ${colors.twilightBlue};
  }
  &.thunderGray,
  &.gray {
    background-color: ${colors.thunderGray};
  }
  &.black {
    background-color: ${colors.black};
  }
  &.rapidBlue {
    background-color: ${colors.rapidBlue};
  }
  &.espressoBrown {
    background-color: ${colors.espressoBrown};
  }

  @media (${bpWidth.desktopSm}) {
    &.boardwalkBeige,
    &.red,
    &.signalRed,
    &.sparkCitron,
    &.shadowBlack,
    &.twilightBlue,
    &.thunderGray,
    &.rapidBlue,
    &.espressoBrown,
    &.starWars,
    &.grogu™Gitamini {
      height: 15px;
      width: 15px;
    }
  }
`;

const ProductVariantSelector = (props) => {
  const { productVariants = [], currentVariant = null, onVariantChanged } = props;
  const [allVariants, setAllVariants] = useState([]);

  useEffect(() => {
    if (window.location.pathname === '/shop/g1t4-m1n1' || window.location.pathname === '/shop/grogu') {
      setAllVariants([
        ...productVariants,
        { color: 'sparkCitron', title: 'Spark Citron', pageUrl: '/shop/gitamini?color=sparkCitron' },
        { color: 'boardwalkBeige', title: 'Boardwalk Beige', pageUrl: '/shop/gitamini?color=boardwalkBeige' },
      ]);
    } else if (window.location.pathname === '/shop/gitamini') {
      setAllVariants([{ color: 'starWars', title: 'StarWars G1', pageUrl: '/shop/grogu' }, ...productVariants]);
    } else {
      setAllVariants(productVariants);
    }
  }, [productVariants]);

  // query custom icon
  const themeQuery = useStaticQuery(graphql`
    {
      iconG1t4: file(name: { eq: "G1T4-M1N1-icon" }) {
        publicURL
      }
      iconGrogu: file(name: { eq: "grogu-icon" }) {
        publicURL
      }
    }
  `);

  return (
    <VariantSelectionContainer>
      {allVariants.map((variant) => {
        const variantOptionStyle =
          variant.color === 'starWars' || variant.color?.includes('Grogu')
            ? {
                backgroundImage: `url(${themeQuery.iconGrogu?.publicURL})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }
            : variant.color?.includes('G1T4-M1N1')
              ? {
                  backgroundImage: `url(${themeQuery.iconG1t4?.publicURL})`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                }
              : { backgroundColor: variant.color };

        return (
          <VariantSelection
            key={variant.storefrontId || variant.title}
            className={currentVariant?.storefrontId === variant.storefrontId ? 'active' : undefined}
          >
            <VariantOption
              className={
                variant.color === 'starWars' || variant.color?.includes('G1T4-M1N1')
                  ? 'starWars'
                  : _.camelCase(variant.title)
              }
              style={variantOptionStyle}
              onClick={() => {
                if (variant.pageUrl) {
                  navigate(variant.pageUrl);
                } else {
                  onVariantChanged(variant);
                }
              }}
            />
          </VariantSelection>
        );
      })}
    </VariantSelectionContainer>
  );
};

ProductVariantSelector.propTypes = {
  currentVariant: object,
  onVariantChanged: func,
  productVariants: array,
};
ProductVariantSelector.defaultProps = { productVariants: [], onVariantChanged: () => {} };

export default ProductVariantSelector;
